module.exports = __webpack_public_path__ + "static/wareef-pillar-of-the-gcc-c6a97cead05017c813add7b73cecb2bc.jpg";